import { Card, CardContent } from "@/components/ui/card";

export const KeyConsiderations = () => {
  return (
    <Card className="mt-8 bg-blue-50">
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold mb-4">Key Investment Considerations</h3>
        <div className="grid gap-4">
          <div className="flex items-start gap-2">
            <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <span className="text-blue-600 font-semibold">1</span>
            </div>
            <div>
              <h4 className="font-medium">Strategic Focus on Product Development</h4>
              <p className="text-sm text-gray-600">
                40% allocation to product development ensures continuous innovation and platform enhancement.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <span className="text-blue-600 font-semibold">2</span>
            </div>
            <div>
              <h4 className="font-medium">Team Growth & Expertise</h4>
              <p className="text-sm text-gray-600">
                Significant investment in human capital to drive execution and innovation.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <span className="text-blue-600 font-semibold">3</span>
            </div>
            <div>
              <h4 className="font-medium">Balanced Allocation</h4>
              <p className="text-sm text-gray-600">
                Thoughtful distribution across key business areas ensures sustainable growth.
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
